import React from 'react';
import './ConfirmationPopup.css';

const ConfirmationPopup = ({ 
    isOpen, 
    onCancel, 
    onConfirm, 
    title = "Potwierdzenie", 
    message = "Czy na pewno chcesz kontynuować?", 
    confirmText = "Tak", 
    cancelText = "Nie", 
    style = "normal" 
}) => {
    if (!isOpen) return null;

    const handleBackdropClick = (e) => {
        if (e.target === e.currentTarget) {
            onCancel();
        }
    };

    const getStyleClass = () => {
        return style === "destructive" ? "destructive" : "normal";
    };

    return (
        <div className="confirmation-overlay" onClick={handleBackdropClick}>
            <div className={`confirmation-popup ${getStyleClass()}`}>
                <div className="popup-header">
                    <h3>{title}</h3>
                </div>
                <div className="popup-content">
                    <p>{message}</p>
                </div>
                <div className="popup-actions">
                    <button 
                        className="cancel-btn"
                        onClick={onCancel}
                    >
                        {cancelText}
                    </button>
                    <button 
                        className={`confirm-btn ${getStyleClass()}`}
                        onClick={onConfirm}
                    >
                        {confirmText}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ConfirmationPopup;
